app.service('deliveryShops', function(console, front, pageConfig ) {
	var config;

	function refresh(params, callback) {
		var frontPlace = front.group();

		if (!config) {
			config = pageConfig.getData(frontPlace);
		}
		var data = {
			city: config.cityCode,
			store_code: config.shopCode,
			location: config.location,
			filtered: config.hasOnlySmall,
			lastOrderShopCode:config.lastOrderShopCode,
			orderNumber: config.orderNumber
		};

		$.extend(true, data, params);
		$.ajax({
			url:'/orderSelectShop.ltr',
			method:'get',
			data: data,
			success: function(html){
				callback(html);
			}
		});
	}
	function refreshSuccess(html){
		config.lastOrderShopCode=false;
		if ($('input[name="paymentType"][value="5"]:checked').length) {
			$('#shops-list').addClass('delivery-time-not-changeable');
		}
	}
	function selectCityParams(cityCode) {
		if (cityCode !== '') {
			return {
				city: cityCode,
				store_code: ''
			};
		}
	}
	function findNearParams(position) {
		return {
			city:'',
			latitude:position.coords.latitude,
			longitude:position.coords.longitude
		};
	}
	function selectLocation(location) {
		console.log('WYBRANIE SKLEPU - ' + location.shop + ' | ' + location.city);
		$('#shop-code').val(location.shop).valid();
		$('#city-code').val(location.city).valid();
		config.shopCode = location.shop;
		config.cityCode = location.city;
	}

	return {
		refresh:refresh,
		refreshSuccess:refreshSuccess,
		selectCityParams:selectCityParams,
		findNearParams: findNearParams,
		selectLocation: selectLocation
	};
});
